import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import CustomChartTooltip from './CustomChartTooltip';

const DockUtilizationChart = ({ data }) => {
    const isEmpty = !data || data.length === 0;

    return (
        <div style={{ width: '100%', height: 300 }}>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '1.1rem', fontWeight: 'var(--font-bold)', color: 'var(--text-primary)' }}>Rampa Kullanım Oranları</h3>
            {isEmpty ? (
                <div className="flex items-center justify-center" style={{ height: '250px' }}>
                    <div className="text-secondary italic opacity-60">Veri Yok</div>
                </div>
            ) : (
                <ResponsiveContainer>
                    <BarChart
                        data={data}
                        layout="vertical"
                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke="var(--border-color)" horizontal={true} vertical={false} />
                        <XAxis type="number" stroke="var(--text-secondary)" />
                        <YAxis
                            type="category"
                            dataKey="name"
                            stroke="var(--text-secondary)"
                            width={70}
                            tick={{ fontSize: 11 }}
                        />
                        <Tooltip cursor={{ fill: 'rgba(255,255,255,0.03)' }} content={<CustomChartTooltip />} />
                        <Bar dataKey="count" name="İşlem Sayısı" fill="var(--secondary-color)" radius={[0, 4, 4, 0]} barSize={20}>
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};

export default DockUtilizationChart;
